import { lazy } from 'react';

import { ALLOWED_ROLES } from 'packages/utils';

import { PATHS } from './constants';

const GroupsList = lazy(() => import('./screens/GroupsList'));
const Group = lazy(() => import('./screens/Group'));

const routesRoutes = [
  {
    component: GroupsList,
    path: PATHS.BASE_URL,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.GROUPS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: Group,
    path: PATHS.EDIT_GROUP,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.GROUPS.UPDATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: Group,
    path: PATHS.CREATE_GROUP,
    writeOnly: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.GROUPS.CREATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
];

export default routesRoutes;
